import { OrganizationUserType } from '@mfw/common';

import {
  useActingUserType,
  useOrganizationContext,
  usePermissionsContext,
} from '../../context';

/**
 * Shared eligibility for navigation to the selected organization's clients
 * list. The list itself only costs `users_read` on the backend
 * (`organization.clients.controller.ts` `findAll`), so that is the permission
 * checked — `users_update` / `client_memberships_manage` are not, otherwise
 * `assistant_trainer` (who reads and coaches clients but edits nothing) lost
 * the row. The seeded `client` role also holds `users_read`, so `!isClient`
 * is what keeps the staff view from clients, same as `canManageSchedule`.
 */
export function useCanReadClients(organizationId?: string) {
  const { currentOrganization } = useOrganizationContext();
  const { hasPermission } = usePermissionsContext();
  const isClient = useActingUserType() === OrganizationUserType.CLIENT;

  return Boolean(
    currentOrganization?.id &&
    (!organizationId || currentOrganization.id === organizationId) &&
    !isClient &&
    hasPermission('users_read'),
  );
}
